import React from 'react'
import ContentAccordion from '../../../components/ContentAccordion'
import ContentSectionHeader from '../../../components/ContentSectionHeader'
import styled from 'styled-components'
import { media, Container } from '../../../utils/style'

const slugg = require('slugg')

const ContentAccordionContainer = styled(Container)`
  padding: 50px 0;
  position: relative;
  line-height: 1.7;
  max-width: 95%;
  ${media.MediumScreenUp`
    max-width: 75%;
  `};
  ${media.LargeScreenUp`
    max-width: 60%;
  `};
`

const Faq = ({ faq }) => {
  const urlSlug =
    typeof window !== 'undefined' ? window.location.hash.substr(1) : ''
  const slug = `faq-${slugg(faq.title)}`

  const onOpen = () => {
    history.replaceState(undefined, undefined, `#${slug}`)
  }

  const onClose = () => {
    history.replaceState(undefined, undefined, '#')
  }

  return (
    <ContentAccordion
      id={slug}
      collapsed={slug !== urlSlug}
      title={faq.title}
      faq
      onOpen={onOpen}
      onClose={onClose}
    >
      <div dangerouslySetInnerHTML={{ __html: faq.body }} />
    </ContentAccordion>
  )
}

const FaqSelectorWidget = ({ faqs, faqTags, title, text }) => {
  const items = faqs || faqTags || []
  return (
    <div>
      {title && (
        <div style={{ backgroundColor: '#EEF4F9', padding: '50px 0' }}>
          <ContentSectionHeader title={title} fg="#1E4F67">
            {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
          </ContentSectionHeader>
        </div>
      )}
      <ContentAccordionContainer role="tablist">
        {items.map((faq, i) => (
          <Faq key={`accordion-item-${i}`} faq={faq} />
        ))}
      </ContentAccordionContainer>
    </div>
  )
}

export default FaqSelectorWidget
